<template>
  <div>
    <v-toolbar text color="white">
      <v-row>
        <v-col>
          <v-btn v-show="tableData && tableData.length>0 && isDownloable" @click="onexport" text>
            <v-icon>cloud_download</v-icon>
            Скачать
          </v-btn>
        </v-col>
        <v-col>
          <div>
            <h3>
              {{ tableName }}
            </h3>
          </div>
        </v-col>
      </v-row>
      <slot name="info" />
      <v-spacer />
      <v-text-field v-if="isSearchable"
                    v-model.trim="search"
                    append-icon="search"
                    label="Поиск"
                    single-line
                    hide-details />
    </v-toolbar>
    <v-data-table ref="sortableTable"
                  :headers="headers"
                  :items="tableData"
                  :loading="loading"
                  :no-data-text="noDataText"
                  :no-results-text="noDataText"
                  :disable-pagination="true"

                  :sortable="sortable"
                  :sort-desc="true"
                  :sort-by="sortBy"
                  :group-by="groupBy"
                  :item-key="itemKey"
                  :search="search"
                  :show-group-by="isGroupable"
                  hide-default-footer
                  class="elevation-1"
                  fixed-header>
      <!--      <template v-slot:header="props">-->
      <!--        <slot name="secondRow" />-->
      <!--        <tr>-->
      <!--          <th v-for="header in props.headers"-->
      <!--              :key="header.value"-->
      <!--              :style="'width:'+header.width"-->
      <!--              :class="['table-header-center', 'column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"-->
      <!--              @click="changeSort(header.value)">-->
      <!--            <v-icon v-if="sortable" small>-->
      <!--              arrow_upward-->
      <!--            </v-icon>-->
      <!--            {{ header.text }}-->
      <!--          </th>-->
      <!--        </tr>-->
      <!--      </template>-->
      <!--      <template v-slot:header="props">-->
      <!--        <thead>-->
      <!--          <tr>-->
      <!--            <template v-for="header in props.props.headers">-->
      <!--              <th :key="header.value">-->
      <!--                <span>{{ header.text }}</span>-->
      <!--                <v-btn @click.stop="props.on.sort(header.value)" icon>-->
      <!--                  <v-icon>keyboard_arrow_down</v-icon>-->
      <!--                </v-btn>-->
      <!--                <v-btn @click.stop="props.on.group(header.value)" icon>-->
      <!--                  <v-icon>flip_to_back</v-icon>-->
      <!--                </v-btn>-->
      <!--              </th>-->
      <!--            </template>-->
      <!--          </tr>-->
      <!--        </thead>-->
      <!--      </template>-->
      <template v-slot:item="props">
        <!--{{props.item}}-->
        <!--{{props.item.product}}-->
        <template v-if="!Array.isArray(props.item)">
          <tr @click="props.expanded = !props.expanded" class="sortableRow">
            <td v-if="isDragable && isMovable" class="px-1" style="width: 0.1%">
              <v-btn style="cursor: move" icon class="sortHandle">
                <v-icon>drag_handle</v-icon>
              </v-btn>
            </td>
            <td v-for="(value, key) in props.item"
                :key="`${key}-${value}`"
                :class="['table-header-center']"
                :style="{display: (value && key==='id' || key==='deleted' || key==='importance' || headers.filter(v=>v.value===key && v.align==='d-none').length>0 ? 'none' : '[]' )}">
              <template v-if="!Array.isArray(value) && typeof value!=='boolean'">
                <template v-if="columnTypesMapping && key in columnTypesMapping && columnTypesMapping[key].type==='url'">
                  <a v-if="'text' in columnTypesMapping[key]" :href="value" target="_blank">{{ value }}</a>
                  <a v-else :href="value" target="_blank">Перейти</a>
                </template>
                <template v-else>
                  <template v-if="columnTypesMapping && key in columnTypesMapping && columnTypesMapping[key].type==='date'">
                    <span>{{ fullDateFormat(value) }}</span>
                  </template>
                  <template v-else>
                    {{ value }}
                  </template>
                </template>
              </template>
              <template v-else-if="typeof value==='boolean'">
                <v-checkbox v-model="props.item.actionTaken"
                            @change="checkBoxChange(props.item, props.index)"
                            primary
                            hide-details />
              </template>
              <template v-else>
                <ul style="list-style-type: none;">
                  <li v-for="(val, key) in value" :key="key">
                    {{ val }}
                  </li>
                </ul>
              </template>
            </td>

            <!--<td v-if="additionalHeaders.length>0" :class="['table-header-center']" v-for="(value, key) in additionalHeaders" >-->
            <!--{{value}} {{props.item}}-->

            <!--</td>-->
          </tr>
        </template>
        <template v-else>
          <!--{{props.item.product}}-->
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.amount }}</td>
        </template>
      </template>

      <template v-if="isExpandable" v-slot:expand="props">
        <v-card text>
          <v-card-text>{{ props.item.text }}</v-card-text>
        </v-card>
      </template>
      <template v-slot:body.append>
        <slot name="summary" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {exportXls} from '../../utils'
import Sortable from 'sortablejs'

export default {
  name: "ReportTable",
  props: {
    headers: {
      type: [Array, Object],
      default: () => []
    },
    data: {
      type: [Array, Object]
      // default:  ()=> {}
    },
    sortable: {
      type: Boolean,
      default: true
    },
    isMovable: {
      type: Boolean,
      default: true
    },
    isGroupable: {
      type: Boolean,
      default: true
    },
    noDataText: {
      type: String,
      default: 'Нет данных'
    },
    loading: {
      type: Boolean,
      default: true
    },
    additionalHeaders: {
      type: [Array, Object],
      default: () => []
    },
    isSearchable: {
      type: Boolean,
      default: true
    },
    tableName: {
      type: String,
      default: 'Таблица'
    },
    isDownloable: {
      type: Boolean,
      default: true
    },
    isDragable: {
      type: Boolean,
      default: true
    },
    itemKey: {
      type: String,
      default: 'name'
    },
    sortBy: {
      type: Array,
      default: () => ['importance', 'name','amount']
    },
    isExpandable: {
      type: Boolean,
      default: false
    },
    columnTypesMapping: {
      type: Object,
      default: () => {
      }
    }, groupBy: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      isLoading: true,
      search: "",
      pagination: {
        sortBy: this.sortBy
      },
      expand: false
    }
  },
  computed: {
    tableData () {
      //console.log('tabledata', this.data)
      let d
      if (typeof this.data === 'object') {
        if (Object.entries(this.data).length === 0) {
          d = []
        } else {
          d = Array.isArray(this.data) ? this.data : [this.data]
        }
      } else {
        d = this.data
      }

      return d
    }
    ,
    json_fields () {
      let d = {}
      this.headers.forEach(head => {
        d[head.value] = head['text']
      })
      return d
      // 'Код клиента': 'full_code',
      // 'Пол клиента': 'sex',
      // 'Дата рождения': 'date_of_birth',
      // 'Возраст' : 'age',
      // 'Всего контактов' : 'overall'

    }

  },
  mounted () {
    /* eslint-disable no-new */
    if (this.isMovable){
      new Sortable(
        this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
        {
          draggable: '.sortableRow',
          handle: '.sortHandle',
          onEnd: this.dragReorder
        }
    )
    }

  },
  methods: {
    dragReorder ({oldIndex, newIndex}) {
      let tableCopy = this.tableData.slice()
      const oldVal = tableCopy[newIndex]
      const newVal = tableCopy[oldIndex]
      this.tableData[newIndex] = newVal
      this.tableData[oldIndex] = oldVal

    },
    changeSort (column) {
      if (this.sortable) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      }
    },
    onexport () { // On Click Excel download button
      let dataToExcel = this.tableData
      exportXls(dataToExcel, this.json_fields, this.tableName)
    },
    checkBoxChange (val, index) {
      this.$emit('onCheckBoxChange', val, index)
    }
  }
}
</script>

<style lang="scss" scoped>
.table-header-left {
  text-align: left;
}

.table-header-center {
  text-align: center;
}

> > > tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05) !important;
}


> > > .theme--light.v-table tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05) !important;

}
</style>



// WEBPACK FOOTER //
// src/components/reports/ReportTable.vue